import React, { useState, useEffect } from 'react';
import styled from 'styled-components';

const Card = styled.div`
  background-color: #172A2A;
  border-radius: 24px;
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  
  @media (max-width: 768px) {
    padding: 16px;
    gap: 12px;
    border-radius: 16px;
  }
`;

const CardHeader = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  margin-bottom: 0;
`;

const CardTitle = styled.h2`
  font-family: 'Ubuntu', sans-serif;
  font-weight: 500;
  font-size: 16px;
  line-height: 1.5;
  color: #FFFFFF;
  margin: 0;
`;

interface CardContentProps {
  $isVisible: boolean;
}

const CardContent = styled.div<CardContentProps>`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  opacity: ${props => props.$isVisible ? '1' : '0'};
  transition: opacity 0.3s ease;
  
  @media (max-width: 768px) {
    gap: 12px;
  }
`;

interface ProfileCardProps {
  title: string;
  children: React.ReactNode;
  tutorialId?: string;
}

const ProfileCard: React.FC<ProfileCardProps> = ({ 
  title, 
  children,
  tutorialId
}) => {
  const [isContentVisible, setIsContentVisible] = useState(false);
  
  useEffect(() => {
    // Небольшая задержка перед отображением контента
    const timer = setTimeout(() => {
      setIsContentVisible(true);
    }, 200);
    
    return () => clearTimeout(timer);
  }, []);
  
  return (
    <Card data-tutorial={tutorialId}>
      <CardHeader>
        <CardTitle>{title}</CardTitle>
      </CardHeader>
      
      <CardContent $isVisible={isContentVisible}>
        {children}
      </CardContent>
    </Card>
  );
};

export default ProfileCard; 